import conclusionsAPI from 'dashboard/api/conclusions';

const state = {
  records: [],
  record: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
    isError: false,
  },
  popData: [],
};

export const getters = {
  getRecords($state) {
    return $state.records;
  },
  getRecord($state) {
    return $state.record;
  },
  getPop($state) {
    return $state.popData;
  },
};

export const actions = {
  get: async ({ state: $state }, { page, from, to, agents, channels }) => {
    $state.uiFlags.isFetching = true;
    try {
      const { data } = await conclusionsAPI.get({
        page,
        from,
        to,
        agents,
        channels,
      });
      $state.records = data;
    } catch (error) {
      throw new Error(error);
    } finally {
      $state.uiFlags.isFetching = false;
    }
  },

  show: async ({ state: $state }, conversation_id) => {
    $state.uiFlags.isFetching = true;
    try {
      const { data } = await conclusionsAPI.get({ conversation_id });
      $state.record = data;
    } catch (error) {
      throw new Error(error);
    } finally {
      $state.uiFlags.isFetching = false;
    }
  },

  set: async (
    { state: $state },
    { conversation_id, status, remark, phone }
  ) => {
    $state.uiFlags.isFetching = true;
    try {
      await conclusionsAPI.create({
        conversation_id,
        status,
        remark,
        phone,
      });
    } catch (error) {
      throw new Error(error);
    } finally {
      state.uiFlags.isFetching = false;
    }
  },

  update: async ({ state: $state }, { id, status, remark, solution }) => {
    $state.uiFlags.isFetching = true;
    try {
      await conclusionsAPI.update(id, {
        status,
        remark,
        solution,
      });
    } catch (error) {
      throw new Error(error);
    } finally {
      $state.uiFlags.isFetching = false;
    }
  },

  batch: async ({ state: $state }, { ids, status, remark }) => {
    $state.uiFlags.isFetching = true;
    try {
      await conclusionsAPI.batch({
        ids,
        status,
        remark,
      });
    } catch (error) {
      throw new Error(error);
    } finally {
      $state.uiFlags.isFetching = false;
    }
  },

  pop_data: async ({ state: $state }, { page, phone }) => {
    $state.uiFlags.isFetching = true;
    try {
      const { data } = await conclusionsAPI.pop_data({
        page,
        phone,
      });
      $state.popData = data;
    } catch (error) {
      throw new Error(error);
    } finally {
      $state.uiFlags.isFetching = false;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
};
